import ImagePreview from 'components/atoms/ImagePreview'
import React from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { useWizard } from 'react-use-wizard'
import { DocumentAddStep } from '../model'
import '../styles.scss'

interface StepReviewPhotoProps {
  photo: string
  onPhotoSelected: (photo: string) => void
}

const StepPreviewPhoto = (props: StepReviewPhotoProps): JSX.Element => {
  const { nextStep, previousStep } = useWizard()

  const onUsePhotoClick = () => {
    props.onPhotoSelected(props.photo)
    nextStep(DocumentAddStep.EditFile)
  }

  return (
    <React.Fragment>
      <Container>
        <Row>
          <Col>
            <h2>Take a Photo</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <p>
              <strong>Photo Preview</strong>
            </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <ImagePreview base64Image={props.photo} />
          </Col>
        </Row>
      </Container>

      <div className='modal-footer modal-footer-custom mt-3'>
        <Button className='footer-btn' onClick={onUsePhotoClick}>
          Use photo
        </Button>
        <Button
          className='footer-btn btn-custom-secondary'
          variant='outline-secondary'
          onClick={() => previousStep(DocumentAddStep.TakePhoto)}
        >
          Take another photo
        </Button>
        <Button
          className='footer-btn btn-custom-secondary'
          variant='outline-secondary'
          onClick={() => previousStep(DocumentAddStep.Start)}
        >
          Cancel
        </Button>
      </div>
    </React.Fragment>
  )
}

export default StepPreviewPhoto
